import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useMediaQuery,
} from "@chakra-ui/react";
import Image from "next/image";
import Loading from "public/images/loading.gif";
import { ReactNode } from "react";

export interface DialogProps {
  loading?: boolean;
  icon?: string | any;
  iconContainerStyles?: string;
  title?: string;
  titleStyles?: string;
  children?: ReactNode;
  isOpen?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  actions?: {
    text: string;
    textColor?: string;
    onClick: () => void;
    primary?: boolean;
    error?: boolean;
    variant?: string;
    bgColor?: string;
  }[];
  size?: string;
  minH?: string;
  contentJustifyContent?: string;
}

const Dialog = ({
  loading,
  icon,
  iconContainerStyles = "w-8 mb-4",
  title,
  titleStyles = "w-5/6 text-center",
  children,
  isOpen,
  onOpen,
  onClose,
  actions,
  size,
  minH,
  contentJustifyContent,
}: DialogProps) => {
  const [isMobile] = useMediaQuery("(max-width: 640px)");
  size = isMobile ? "full" : size || "md";
  isOpen = isOpen ?? true;
  onClose = onClose ?? (() => {});

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered size={size}>
      <ModalOverlay />
      <ModalContent
        minH={minH || {}}
        justifyContent={contentJustifyContent || {}}
      >
        <ModalHeader>
          <div className="flex flex-col content-center items-center">
            {loading ? (
              <div className="w-10">
                <Image src={Loading} layout="responsive" alt="" />
              </div>
            ) : (
              ""
            )}
            {icon ? (
              <div className={iconContainerStyles}>
                <Image src={icon} layout="responsive" alt="" />
              </div>
            ) : (
              ""
            )}
            <p className={titleStyles}>{title}</p>
          </div>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody flexGrow="0">
          {loading ? (
            <>
              <h1 className="flex flex-row justify-center font-medium text-lg mb-4">
                Loading...
              </h1>
              <p className="text-center">{children}</p>
            </>
          ) : (
            children
          )}
        </ModalBody>
        <ModalFooter>
          {actions && actions.length > 0 ? (
            <ButtonGroup variant="ghost" className="self-end" spacing="4">
              {actions.map((action, i) => {
                return (
                  <Button
                    color={
                      action.primary
                        ? "primary.300"
                        : action.error
                        ? "white"
                        : "neutral.200"
                    }
                    variant={action.variant || {}}
                    onClick={action.onClick}
                    key={i}
                    fontSize="0.9em"
                    bgColor={action.bgColor || {}}
                  >
                    {action.text}
                  </Button>
                );
              })}
            </ButtonGroup>
          ) : (
            <></>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default Dialog;
